import { useHealthblocksSWR, useSubjectId } from '@healthblocks-io/core'

import type { MedicationHealthProfile } from '../types/HealthProfile.types'

export function useMedicationSchedule() {
  const subjectId = useSubjectId()
  const queryParameters = new URLSearchParams()
  queryParameters.append('v', '9')

  if (subjectId) {
    queryParameters.append('subjectId', String(subjectId))
  }

  const queryString = queryParameters.toString()

  return useHealthblocksSWR<MedicationHealthProfile>(`/views/patient/health-profile/medication?${queryString}`)
}
